import { Component, Input, OnInit } from '@angular/core';


export interface pagos {
  'Concepto': string, 'Monto': number, 'ValorAPagar': string, 
  'numeroDocumento': string, id: string, "codigoFamilia": string, checked: boolean, idEstudiante: number,
  montoDescuento: number, montoPendienteRecargo: number, montoPendiente:number
}

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  @Input() Info: pagos;

  constructor() { }

  ngOnInit() {}

}
